import request from '../utils/request'

export function getList (data) {
  return request({
    url: '/app/wap/getList',
    method: 'post',
    data
  })
}

export function getFirmList (data) {
  return request({
    url: '/app/wap/getFirmList',
    method: 'post',
    data
  })
}

export function detail (data) {
  return request({
    url: '/app/wap/info',
    method: 'post',
    data
  })
}
export function getWapSeriasList (data) {
  // 获取设备系列--联吧H5
  return request({
    url: '/app/wap/getWapSeriasList',
    method: 'post',
    data
  })
}

export function getWapCateList (data) {
  // 下级类目获取--联吧
  return request({
    url: '/app/wap/getWapCateList',
    method: 'post',
    data
  })
}

export function getWapList (data) {
  // 内容获取--联吧H5
  return request({
    url: '/app/wap/getWapList',
    method: 'post',
    data
  })
}

export function getWapSearchList (data) {
  // 搜索--联吧H5
  return request({
    url: '/app/wap/getWapSearchList',
    method: 'post',
    data
  })
}
export function getInfo (data) {
  // 详情--联吧H5
  return request({
    url: '/app/wap/info',
    method: 'post',
    data
  })
}
export function getFirmCateList (data) {
  // 下级类目获取--企业h5
  return request({
    url: '/app/wap/getFirmCateList',
    method: 'post',
    data
  })
}
export function getWapFirmList (data) {
  // 内容获取-企业H5
  return request({
    url: '/app/wap/getWapFirmList',
    method: 'post',
    data
  })
}
export function getFirmInfo (data) {
  // 详情-企业H5
  return request({
    url: '/app/wap/getFirmInfo',
    method: 'post',
    data
  })
}
export function getWapFirmSearchList (data) {
  // 搜索-企业H5
  return request({
    url: '/app/wap/getWapFirmSearchList',
    method: 'post',
    data
  })
}
